<template>
<div class="py-12 px-4">
      <nav class="mb-2 flex flex-wrap justify-between">
      </nav>
       <div class="mb-5 flex flex-col lg:flex-row">
          <div
            class="box shadow-md flex flex-col justify-center items-center py-4 px-8 lg:w-max w-full"
          >
        <label for="family-head-idcard-input" class="form-label text-theme-98">เลขบัตรประจำตัวประชาชน <span class="text-theme-5">*</span></label>
                        <input 
                          id="family-head-idcard-input" 
                          type="text" 
                          class="form-control placeholder-theme-19"
                          placeholder="กรุณากรอกเลขบัตรประชาชน" 
                          data-test="family-head-idcard"
                          maxlength="13"
                          v-model="state.idCardNumber"  
                          @input="onlyNumber"/>
                        <div class="xs:col-span-2 md:col-span-2 pt-7">
                      <button 
                        type="button" 
                        class="btn btn-primary w-15 font-medium" 
                        data-test="submit-add-family-button"
                        @click="checkgetPersonInfoFromBora">
                          ค้นหา
                      </button>
                    </div>
        </div>
    </div>
    <div class="mb-5 flex flex-col lg:flex-row">
          <div
            class="box shadow-md flex flex-col justify-center items-center py-4 px-8 lg:w-max w-full"
          >
          {{bora_data}}
          </div>
    </div>
    <div class="mb-5 flex flex-col lg:flex-row">
          <div
            class="box shadow-md flex flex-col justify-center items-center py-4 px-8 lg:w-max w-full"
          >
          {{bora_hh_data}}
          </div>
    </div>
</div>
</template>

<script setup>
import { shallowRef, ref, onMounted, computed, watch, reactive, provide } from "vue";
import axios from "axios";
import { Buffer } from 'buffer';
import store from "@/store";
import { useBoraData } from "@/utils/useBoraData";

const bora_data = ref(null);
const bora_hh_data = ref(null);
const getPersonInfoFromBora_data = ref(null);
const state = reactive({
  idCardNumber: '1149901588313'
})

const checkgetPersonInfoFromBora = async() => {
  const { boraHouseholdInfo, getPersonInfoFromBora } = await useBoraData();
  const getPersonInfoFromBora_data = await getPersonInfoFromBora(state.idCardNumber);
  console.log(getPersonInfoFromBora_data);
}
const onlyNumber = () => {
  state.idCardNumber = state.idCardNumber.replace(/[^\d]/g, "")
  if(state.idCardNumber.length !== 13){
    bora_data.value = null
  } 
}
</script>